'use client';

export const useBraze = async () => {
  if (typeof window !== 'undefined') {
    const { initialize, openSession, logCustomEvent, changeUser, getUser } =
      await import('@/src/utils/braze/braze-export');
    initialize(process.env.NEXT_PUBLIC_BRAZE_API_KEY!, {
      baseUrl: process.env.NEXT_PUBLIC_BRAZE_URL!,
    });
    openSession();
    return {
      logCustomEvent,
      changeUser,
      getUser,
    };
  }
};
